import { AchatIcon } from "@assets/icons/achatIcon";
import { AddIcon } from "@assets/icons/AddIcon";
import { Dashboard } from "@assets/icons/dashboard";
import { Devis } from "@assets/icons/Devis";
import "./index.scss";
import { useTranslation } from "react-i18next";
import { VenteIcon } from "@assets/icons/venteIcon";
import { ClientsIcon } from "@assets/icons/clientsIcon";
import { OffersIcon } from "@assets/icons/OffersIcon";
import { useContext, useState } from "react";
import { CreateModalContext } from "layouts/appLayout/layout";
import CreateOfferComponent from "@components/CreateOfferComponent/CreateOfferComponent";
import { useLocation, useNavigate } from "react-router-dom";
import { PATHS } from "config/paths";
import ReduireIcon from "@assets/icons/ReduireIcon";
import BusinessIcon from "@mui/icons-material/Business";
import CreateSupplierComponent from "@components/CreateSupplierComponent/CreateSupplierComponent";
import CreateClientComponent from "@components/CreateClientComponent/CreateClientComponent";
import CreateExpenseComponent from "@components/createExpenseComponent/CreateExpenseComponent";
import SettingsIcon from "@mui/icons-material/Settings";
import HasPermission from "HasPermission/HasPermission";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import AdminPanelSettingsOutlinedIcon from "@mui/icons-material/AdminPanelSettingsOutlined";
import CreateUserComponent from "@pages/users/CreateUserComponent/CreateUserComponent";
import CreateRoleComponent from "@pages/roles/CreateRoleComponent/CreateRoleComponent";
import CreateProjectComponent from "@pages/project/CreateProjectComponent/CreateProjectComponent";
import CreateProjectComponentAdmin from "@pages/project/CreateProjectComponentAdmin/CreateProjectComponentAdmin";
import CreatePack from "@components/CreatePack/CreatePack";
import EditDocumentIcon from "@mui/icons-material/EditDocument";
import BeachAccessIcon from "@mui/icons-material/BeachAccess";
import LineWeightIcon from "@mui/icons-material/LineWeight";

export const NavItems = ({ isCollapsed, toggleSidebar }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { toggleCreateModal } = useContext(CreateModalContext);

  // Pour chaque section : Vente & Achat
  const [openSection, setOpenSection] = useState(null);

  const isActive = (path) => location.pathname === path;

  const toggleSection = (section) => {
    setOpenSection(openSection === section ? null : section);
  };

  const handleNavigate = (path) => {
    navigate(path);
  };

  const handleCreateInvoice = (e) => {
    e.stopPropagation();
    navigate(PATHS.INVOICES.CREATE);
  };

  const handleCreateRole = (e) => {
    e.stopPropagation();
    toggleCreateModal(
      <CreateRoleComponent
        onClose={() => {
          toggleCreateModal(<></>);
        }}
      />,
      t("role.title_create")
    );
  };
  const handleCreateExpense = (e) => {
    e.stopPropagation();
    navigate(PATHS.SUPPLIER.CREATE);
  };

  const handleCreateQuote = (e) => {
    e.stopPropagation();
    navigate(PATHS.QUOTES.CREATE);
  };

  const handleCreateconge = (e) => {
    e.stopPropagation();
    navigate(PATHS.CONGE.CREATE);
  };

  const handleCreateAvoir = (e) => {
    e.stopPropagation();
    navigate(PATHS.AVOIRS.CREATE);
  };

  const handleCreateOffer = (e) => {
    e.stopPropagation();
    toggleCreateModal(
      <CreateOfferComponent
        onClose={() => {
          toggleCreateModal(<></>);
        }}
      />,
      t("offer.create_form.title")
    );
  };
  const handleCreateSupplier = (e) => {
    e.stopPropagation();
    toggleCreateModal(
      <CreateSupplierComponent
        onClose={() => {
          toggleCreateModal(<></>);
        }}
        isUpdate={false}
      />,
      t("supplier.create_supplier")
    );
  };

  const handleCreateClient = (e) => {
    e.stopPropagation();
    toggleCreateModal(
      <CreateClientComponent
        onClose={() => {
          toggleCreateModal(<></>);
        }}
      />,
      t("client.create_form.title")
    );
  };

  const handleCreateProjects = (e) => {
    e.stopPropagation();
    toggleCreateModal(
      <CreateProjectComponent
        onClose={() => {
          toggleCreateModal(<></>);
        }}
      />,
      t("projects.create_form.title")
    );
  };
  const handleCreateProjectsAdmin = (e) => {
    e.stopPropagation();
    toggleCreateModal(
      <CreateProjectComponentAdmin
        onClose={() => {
          toggleCreateModal(<></>);
        }}
      />,
      t("projects.create_form.title")
    );
  };
  const handleCreateArticle = (e) => {
    e.stopPropagation();
    toggleCreateModal(
      <CreateExpenseComponent
        onClose={() => {
          toggleCreateModal(<></>);
        }}
        isUpdate={false}
      />,
      t("depense.title_create")
    );
  };
  const handleCreateUsers = (e) => {
    e.stopPropagation();
    toggleCreateModal(
      <CreateUserComponent
        onClose={() => {
          toggleCreateModal(<></>);
        }}
      />,
      t("users.title_create")
    );
  };
  const handleCreatePack = (e) => {
    e.stopPropagation();
    toggleCreateModal(
      <CreatePack
      // onClose={() => {
      //   toggleCreateModal(<></>);
      // }}
      />,
      t("pack.create")
    );
  };

  return (
    <div className="nav-items">
      <div className="sidebar-reduire-btn" onClick={toggleSidebar}>
        <ReduireIcon />
        {!isCollapsed && (t("sidebar.reduce") || "Réduire")}
      </div>

      <div
        className="sidebar-dashboard-btn"
        onClick={() => handleNavigate(PATHS.DASHBOARD_USER)}>
        <Dashboard /> {t("sidebar.dashboard") || "Dashboard"}
      </div>
      <HasPermission permission={["READ_PACK"]}>
        <div
          className="sidebar-parent-items mt-3"
          onClick={() => toggleSection("pack")}>
          <BusinessIcon /> {t("sidebar.pack") || "Pack"}
        </div>
        {openSection === "pack" && (
          <>
            <HasPermission permission={["READ_PACK"]}>
              <div
                className="sidebar-children-items"
                // TODO: add link to pack list
                onClick={() => handleNavigate(PATHS.PACK.LIST)}>
                <div className="d-flex gap-2">
                  <BusinessIcon /> {t("sidebar.pack")}
                </div>
                <HasPermission permission={["CREATE_PACK"]}>
                  <div onClick={handleCreatePack}>
                    <AddIcon />
                  </div>
                </HasPermission>
              </div>
            </HasPermission>
          </>
        )}
      </HasPermission>
      <HasPermission permission={["READ_USER", "view_role"]}>
        <div
          className="sidebar-parent-items mt-3"
          onClick={() => toggleSection("utilisateur")}>
          <PersonOutlineIcon /> {t("sidebar.utilisateur") || "Utilisateur"}
        </div>
        {openSection === "utilisateur" && (
          <>
            <HasPermission permission={["READ_USER"]}>
              <div
                className="sidebar-children-items"
                onClick={() => handleNavigate(PATHS.USERS.LIST)}>
                <div className="d-flex gap-2">
                  <PersonOutlineIcon /> {t("sidebar.utilisateur")}
                </div>
                <HasPermission permission={["CREATE_USER"]}>
                  <div onClick={handleCreateUsers}>
                    <AddIcon />
                  </div>
                </HasPermission>
              </div>
            </HasPermission>
            <HasPermission permission={["view_role"]}>
              <div
                className="sidebar-children-items"
                onClick={() => handleNavigate(PATHS.ROLES.LIST)}>
                <div className="d-flex gap-2">
                  <AdminPanelSettingsOutlinedIcon /> {t("role.role")}
                </div>
                <HasPermission permission={["create_role"]}>
                  <div onClick={handleCreateRole}>
                    <AddIcon />
                  </div>
                </HasPermission>
              </div>
            </HasPermission>
          </>
        )}
      </HasPermission>
      {/* --- Section Vente --- */}
      <HasPermission
        permission={["READ_QUOTE", "READ_INVOICE", "READ_CREDIT_NOTE"]}>
        <div
          className="sidebar-parent-items mt-3"
          onClick={() => toggleSection("vente")}>
          <VenteIcon /> {t("sidebar.sale") || "Vente"}
        </div>
        {openSection === "vente" && (
          <>
            <HasPermission permission={["READ_QUOTE"]}>
              <div
                className="sidebar-children-items"
                onClick={() => handleNavigate(PATHS.QUOTES.LIST)}>
                <div className="d-flex gap-2">
                  <Devis /> {t("sidebar.quote") || "Devis"}
                </div>
                <HasPermission permission={["CREATE_QUOTE"]}>
                  <div onClick={handleCreateQuote}>
                    <AddIcon />
                  </div>
                </HasPermission>
              </div>
            </HasPermission>
            <HasPermission permission={["READ_INVOICE"]}>
              <div
                className="sidebar-children-items"
                onClick={() => handleNavigate(PATHS.INVOICES.LIST)}>
                <div className="d-flex gap-2">
                  <Devis /> {t("sidebar.invoice") || "Factures"}
                </div>
                <HasPermission permission={["CREATE_INVOICE"]}>
                  <div onClick={handleCreateInvoice}>
                    <AddIcon />
                  </div>
                </HasPermission>
              </div>
            </HasPermission>
            <HasPermission permission={["READ_CREDIT_NOTE"]}>
              <div
                className="sidebar-children-items"
                onClick={() => handleNavigate(PATHS.AVOIRS.LIST)}>
                <div className="d-flex gap-2">
                  <Devis /> {t("sidebar.credit_note") || "Avoir"}
                </div>
                <HasPermission permission={["CREATE_CREDIT_NOTE"]}>
                  <div onClick={handleCreateAvoir}>
                    <AddIcon />
                  </div>
                </HasPermission>
              </div>
            </HasPermission>
          </>
        )}
      </HasPermission>
      {/* --- Section Achat --- */}
      <HasPermission permission={["READ_INVOICE_SUPPLIER", "READ_EXPENSE"]}>
        <div
          className="sidebar-parent-items mt-3"
          onClick={() => toggleSection("achat")}>
          <AchatIcon /> {t("sidebar.purchase") || "Depense"}
        </div>
        {openSection === "achat" && (
          <>
            {" "}
            <HasPermission permission={["READ_INVOICE_SUPPLIER"]}>
              <div
                className="sidebar-children-items"
                onClick={() => handleNavigate(PATHS.SUPPLIER.LIST)}>
                <div className="d-flex gap-2">
                  <ClientsIcon /> {t("sidebar.suppliers")}
                </div>
                <HasPermission permission={["CREATE_SUPPLIER"]}>
                  <div onClick={handleCreateSupplier}>
                    <AddIcon />
                  </div>
                </HasPermission>
              </div>
            </HasPermission>
            <HasPermission permission={["READ_EXPENSE"]}>
              <div
                className="sidebar-children-items"
                onClick={() => handleNavigate(PATHS.EXPENSES.LIST)}>
                <div className="d-flex gap-2">
                  <Devis /> {t("depense.name")}
                </div>
                <HasPermission permission={["CREATE_EXPENSE"]}>
                  <div onClick={handleCreateArticle}>
                    <AddIcon />
                  </div>
                </HasPermission>
              </div>
            </HasPermission>
          </>
        )}
      </HasPermission>
      {/* --- Section Client --- */}
      <HasPermission permission={["READ_CLIENT"]}>
        <div
          className="sidebar-parent-items mt-3"
          onClick={() => toggleSection("clients")}>
          <ClientsIcon /> {t("sidebar.clients") || "Clients"}
        </div>
        {openSection === "clients" && (
          <>
            <HasPermission permission={["READ_CLIENT"]}>
              <div
                className={`sidebar-children-items ${
                  isActive(PATHS.CLIENTS.LIST) ? "active" : ""
                }`}
                onClick={() => handleNavigate(PATHS.CLIENTS.LIST)}>
                <div className="d-flex gap-2">
                  <ClientsIcon />
                  {t("sidebar.clients") || "Clients"}
                </div>
                <HasPermission permission={["CREATE_CLIENT"]}>
                  <div onClick={handleCreateClient}>
                    <AddIcon />
                  </div>{" "}
                </HasPermission>
              </div>
            </HasPermission>
          </>
        )}
      </HasPermission>

      {/* --- Offers Sections --- */}
      <HasPermission permission={["READ_OFFER"]}>
        <div
          className="sidebar-parent-items mt-3"
          onClick={() => toggleSection("offers")}>
          <OffersIcon /> {t("sidebar.offers") || "Offres"}
        </div>
        {openSection === "offers" && (
          <>
            {" "}
            <HasPermission permission={["READ_OFFER"]}>
              <div
                className={`sidebar-children-items ${
                  isActive(PATHS.OFFERS) ? "active" : ""
                }`}
                onClick={() => handleNavigate(PATHS.OFFERS)}>
                <div className="d-flex gap-2">
                  <Devis /> {t("sidebar.offers") || "Offres"}
                </div>
                <HasPermission permission={["CREATE_OFFER"]}>
                  <div onClick={handleCreateOffer}>
                    <AddIcon />
                  </div>
                </HasPermission>
              </div>
            </HasPermission>
          </>
        )}
      </HasPermission>
      <HasPermission permission={["SIGNATURE"]}>
        <div
          className="sidebar-parent-items mt-3"
          onClick={() => toggleSection("singature")}>
          <EditDocumentIcon /> {t("sidebar.singature") || "Singature"}
        </div>
        {openSection === "singature" && (
          <>
            {" "}
            <HasPermission permission={["SIGNATURE"]}>
              <div
                className={`sidebar-children-items ${
                  isActive(PATHS.SIGNATURE.LIST) ? "active" : ""
                }`}
                onClick={() => handleNavigate(PATHS.SIGNATURE.LIST)}>
                <div className="d-flex gap-2">
                  <EditDocumentIcon /> {t("sidebar.singature") || "Singature"}
                </div>
              </div>
            </HasPermission>
            <HasPermission permission={["SIGNATURE"]}>
              <div
                className={`sidebar-children-items ${
                  isActive(PATHS.SIGNATURE.TABLE_LIST) ? "active" : ""
                }`}
                onClick={() => handleNavigate(PATHS.SIGNATURE.TABLE_LIST)}>
                <div className="d-flex gap-2">
                  <Devis /> {t("sidebar.singaturelist") || "Singature"}
                </div>
              </div>
            </HasPermission>
          </>
        )}
      </HasPermission>
      <HasPermission permission={["DOCUMENT"]}>
        <div
          className="sidebar-parent-items mt-3"
          onClick={() => toggleSection("document")}>
          <Devis /> {t("sidebar.document") || "Document"}
        </div>
        {openSection === "document" && (
          <>
            <HasPermission permission={["DOCUMENT"]}>
              <div
                className={`sidebar-children-items ${
                  isActive(PATHS.DOCUMENT.LIST) ? "active" : ""
                }`}
                onClick={() => handleNavigate(PATHS.DOCUMENT.LIST)}>
                <div className="d-flex gap-2">
                  <Devis /> {t("sidebar.document") || "Document"}
                </div>
              </div>
            </HasPermission>
          </>
        )}
      </HasPermission>
      <HasPermission permission={["PROJECT"]}>
        <div
          className="sidebar-parent-items mt-3"
          onClick={() => toggleSection("projects")}>
          <LineWeightIcon /> {t("sidebar.projects") || "projects"}
        </div>
        {openSection === "projects" && (
          <>
            <HasPermission permission={["PROJECT"]}>
              <div
                className={`sidebar-children-items ${
                  isActive(PATHS.PROJECT.LIST) ? "active" : ""
                }`}
                onClick={() => handleNavigate(PATHS.PROJECT.LIST)}>
                <div className="d-flex gap-2">
                  <LineWeightIcon /> {t("sidebar.projects") || "projects"}
                </div>
                <HasPermission permission={["PROJECT"]}>
                  <div onClick={handleCreateProjects}>
                    <AddIcon />
                  </div>{" "}
                </HasPermission>
              </div>
            </HasPermission>
          </>
        )}
      </HasPermission>

      <HasPermission permission={["PROJECT_COLLAB"]}>
        <div
          className="sidebar-parent-items mt-3"
          onClick={() => toggleSection("projects")}>
          <LineWeightIcon /> {t("sidebar.projects") || "projects"}
        </div>
        {openSection === "projects" && (
          <>
            <HasPermission permission={["PROJECT_COLLAB"]}>
              <div
                className={`sidebar-children-items ${
                  isActive(PATHS.PROJECT.LISTC) ? "active" : ""
                }`}
                onClick={() => handleNavigate(PATHS.PROJECT.LISTC)}>
                <div className="d-flex gap-2">
                  <LineWeightIcon /> {t("sidebar.projects") || "projects"}
                </div>
              </div>
            </HasPermission>
          </>
        )}
      </HasPermission>

      <HasPermission permission={["PROJECT_ADMIN"]}>
        <div
          className="sidebar-parent-items mt-3"
          onClick={() => toggleSection("projects")}>
          <LineWeightIcon /> {t("sidebar.projects") || "projects"}
        </div>
        {openSection === "projects" && (
          <>
            <HasPermission permission={["PROJECT_ADMIN"]}>
              <div
                className={`sidebar-children-items ${
                  isActive(PATHS.PROJECT.LISTA) ? "active" : ""
                }`}
                onClick={() => handleNavigate(PATHS.PROJECT.LISTA)}>
                <div className="d-flex gap-2">
                  <LineWeightIcon /> {t("sidebar.projects") || "projects"}
                </div>
                <HasPermission permission={["CREATE_PROJECT_ADMIN"]}>
                  <div onClick={handleCreateProjectsAdmin}>
                    <AddIcon />
                  </div>{" "}
                </HasPermission>
              </div>
            </HasPermission>
          </>
        )}
      </HasPermission>
      <HasPermission permission={["CONGE"]}>
        <div
          className="sidebar-parent-items mt-3"
          onClick={() => toggleSection("absence")}>
          <BeachAccessIcon /> {t("sidebar.absence") || "absence"}
        </div>
        {openSection === "absence" && (
          <>
            <HasPermission permission={["CONGE"]}>
              <div
                className={`sidebar-children-items ${
                  isActive(PATHS.CONGE.LIST) ? "active" : ""
                }`}
                onClick={() => handleNavigate(PATHS.CONGE.LIST)}>
                <div className="d-flex gap-2">
                  <BeachAccessIcon /> {t("sidebar.absence") || "absence"}
                </div>
                <HasPermission permission={["CONGE"]}>
                  <div onClick={handleCreateconge}>
                    <AddIcon />
                  </div>{" "}
                </HasPermission>
              </div>
            </HasPermission>
          </>
        )}
      </HasPermission>
      <HasPermission permission={["VALIDATEUR"]}>
        <div
          className="sidebar-parent-items mt-3"
          onClick={() => toggleSection("absence")}>
          <ClientsIcon /> {t("sidebar.requestLeave") || "requestLeave"}
        </div>
        {openSection === "absence" && (
          <>
            <HasPermission permission={["VALIDATEUR"]}>
              <div
                className={`sidebar-children-items ${
                  isActive(PATHS.CONGE.LISTSUPPLIER) ? "active" : ""
                }`}
                onClick={() => handleNavigate(PATHS.CONGE.LISTSUPPLIER)}>
                <div className="d-flex gap-2">
                  <Devis /> {t("sidebar.requestLeave") || "requestLeave"}
                </div>
              </div>
            </HasPermission>
          </>
        )}
      </HasPermission>
      <HasPermission permission={["VALIDATEUR"]}>
        <div
          className="sidebar-parent-items mt-3"
          onClick={() => toggleSection("cra")}>
          <ClientsIcon /> {t("sidebar.validetcra") || "validetcra"}
        </div>
        {openSection === "cra" && (
          <>
            <HasPermission permission={["VALIDATEUR"]}>
              <div
                className={`sidebar-children-items ${
                  isActive(PATHS.CRA.LISTVALIDATION) ? "active" : ""
                }`}
                onClick={() => handleNavigate(PATHS.CRA.LISTVALIDATION)}>
                <div className="d-flex gap-2">
                  <Devis /> {t("sidebar.validetcra") || "validetcra"}
                </div>
              </div>
            </HasPermission>
          </>
        )}
      </HasPermission>
      <HasPermission permission={["CRA"]}>
        <div
          className="sidebar-parent-items mt-3"
          onClick={() => toggleSection("cra")}>
          <Devis /> {t("sidebar.mestemps") || "mestemps"}
        </div>
        {openSection === "cra" && (
          <>
            <HasPermission permission={["CRA"]}>
              <div
                className={`sidebar-children-items ${
                  isActive(PATHS.CRA.LIST) ? "active" : ""
                }`}
                onClick={() => handleNavigate(PATHS.CRA.LIST)}>
                <div className="d-flex gap-2">
                  <Devis /> {t("sidebar.mestemps") || "mestemps"}
                </div>
              </div>
            </HasPermission>
          </>
        )}
      </HasPermission>
      <HasPermission permission={["CONFIGURATION"]}>
        <div
          className="sidebar-dashboard-btn mt-5"
          onClick={() => handleNavigate(PATHS.CONFIGURATION)}>
          <SettingsIcon />
          {t("sidebar.config") || "Configuration"}
        </div>
      </HasPermission>
    </div>
  );
};
